import * as styles from "./DrawerHeader.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { DrawerHeaderProps } from "./Drawer.types";

export function DrawerHeader({
  className,
  ...props
}: DrawerHeaderProps): JSX.Element {
  return (
    <div
      data-slot="drawer-header"
      className={clsx(styles.header, className)}
      {...props}
    />
  );
}
